<input #fileInput title="file" placeholder="Select file." type="file" class="file-input" accept=".xlsx, .xls" (change)="onFileSelect($event);onFileUpload()" #fileUpload>
<div class="filter-header">
  <!-- Unified toolbar -->
  <div class="filter-toolbar">
    <div class="view-toggle">
      <button class="toggle-btn" [class.active]="activeScreen === 'map'" (click)="toMap()">
        <span class="toggle-icon map-icon"></span>Map
      </button>
      <button class="toggle-btn" [class.active]="activeScreen === 'list'" (click)="toGrid()">
        <span class="toggle-icon list-icon"></span>List
      </button>
      <button class="toggle-btn" [class.active]="activeScreen === 'calendar'" (click)="toCalendar()">
        <span class="toggle-icon calendar-icon"></span>Timeline
      </button>
    </div>

    <button class="filter-toggle-btn" [class.active]="filtersOpen" (click)="filtersOpen = !filtersOpen">
      <span class="filter-toggle-icon"></span>
      Filters
      <span class="filter-badge" *ngIf="activeFilterCount > 0">{{activeFilterCount}}</span>
    </button>

    <input class="searchTxt" (keydown.enter)="loadData()" [(ngModel)]="searchText" type="text" placeholder="Search..." />

    <!-- Map tools (only visible on map view) -->
    <ng-container *ngIf="activeScreen === 'map'">
      <span class="toolbar-divider"></span>
      <button class="toolbar-icon-btn"
              [class.active]="map?.showWeatherOverlay"
              [disabled]="map?.weatherLoading"
              (click)="map?.toggleWeatherOverlay()">
        <span class="tb-icon tb-weather-icon"></span>
        <span *ngIf="!map?.weatherLoading">Weather</span>
        <span *ngIf="map?.weatherLoading">Loading...</span>
      </button>
      <button class="toolbar-icon-btn"
              [class.active]="map?.showMeasureTool"
              (click)="map?.enableMeasurement(!map?.showMeasureTool)">
        <span class="tb-icon tb-measure-icon"></span>
        Measure
      </button>
    </ng-container>

    <span class="toolbar-divider"></span>

    <!-- Data menu -->
    <button class="toolbar-menu-btn" [matMenuTriggerFor]="dataMenu">
      <span class="tb-icon tb-data-icon"></span>
      Data
      <span class="tb-icon tb-caret-icon"></span>
    </button>
    <mat-menu #dataMenu="matMenu" class="toolbar-menu">
      <button mat-menu-item (click)="loadFile()" [disabled]="isDownloading">
        <span class="menu-icon download-icon"></span>
        {{isDownloading ? 'Downloading...' : 'Download Data'}}
      </button>
      <button mat-menu-item *ngIf="loginService.user.isGlobalAdmin" (click)="loadShapefile()" [disabled]="isDownloadingShapefile">
        <span class="menu-icon download-icon"></span>
        {{isDownloadingShapefile ? 'Downloading...' : 'Download Shapefile (ArcGIS)'}}
      </button>
      <button mat-menu-item (click)="fileUpload.click()" [disabled]="isUploading">
        <span class="menu-icon upload-icon"></span>
        {{isUploading ? 'Uploading...' : 'Upload Data'}}
      </button>
      <button mat-menu-item *ngIf="loginService.user.enableFracXAutomation" (click)="downloadApiDocs()">
        <span class="menu-icon api-icon"></span>
        API Sample
      </button>
      <button mat-menu-item *ngIf="loginService.user.enableFracXAutomation" (click)="goToGrid()">
        <span class="menu-icon schedule-icon"></span>
        Manage SFTP Schedules
      </button>
    </mat-menu>

    <!-- Manage menu -->
    <button *ngIf="hasManageOptions" class="toolbar-menu-btn" [matMenuTriggerFor]="manageMenu">
      <span class="tb-icon tb-manage-icon"></span>
      Manage
      <span class="tb-icon tb-caret-icon"></span>
    </button>
    <mat-menu #manageMenu="matMenu" class="toolbar-menu">
      <button mat-menu-item *ngIf="loginService.user.isGlobalAdmin" (click)="manageFracXClients()">
        <span class="menu-icon clients-icon"></span>
        Clients
      </button>
      <button mat-menu-item *ngIf="loginService.user.isGlobalAdmin || loginService.user.isCompanyAdmin" (click)="manageFracXUsers()">
        <span class="menu-icon users-icon"></span>
        Users
      </button>
      <button mat-menu-item *ngIf="loginService.user.enableFracXContacts" (click)="contacts()">
        <span class="menu-icon contacts-icon"></span>
        Contacts
      </button>
      <button mat-menu-item *ngIf="loginService.user.isGlobalAdmin || loginService.user.isCompanyAdmin" (click)="archiveSchedules()">
        <span class="menu-icon schedule-icon"></span>
        Archive Schedules
      </button>
    </mat-menu>

    <div class="toolbar-actions">
      <button (click)="clearFilters()" class="action-btn reset-btn">
        <span>Reset</span>
      </button>
      <button (click)="loadData()" class="action-btn apply-btn">
        <span>Apply</span>
      </button>
    </div>
  </div>

  <!-- Row 2: Collapsible filter panel -->
  <div class="filter-panel" [class.open]="filtersOpen">
    <div class="filter-panel-inner">
      <div class="filter-panel-grid">
        <div class="filter-field">
          <label class="filter-field-label">Region</label>
          <mat-select class="mat-select-filter" [(ngModel)]="regions" multiple>
            @for (filter of filters.regions; track filter){
            <mat-option class="mat-option-filter" [value]="filter.value">{{filter.caption}}</mat-option>
            }
          </mat-select>
        </div>

        <div class="filter-field">
          <label class="filter-field-label">State/County</label>
          <mat-select class="mat-select-filter" [(ngModel)]="stateCounties" multiple>
            @for (filter of filters.stateCounty; track filter){
            <mat-option class="mat-option-filter" [value]="filter.value">{{filter.caption}}</mat-option>
            }
          </mat-select>
        </div>

        <div class="filter-field">
          <label class="filter-field-label">Company</label>
          <mat-select class="mat-select-filter" [(ngModel)]="operators" multiple>
            @for (filter of filters.operators; track filter){
            <mat-option class="mat-option-filter" [value]="filter.value">{{filter.caption}}</mat-option>
            }
          </mat-select>
        </div>

        <div class="filter-field filter-field-days">
          <label class="filter-field-label">Scheduled In Next</label>
          <div class="days-input-row">
            <mat-slider [max]="500" [min]="0" [step]="10" [discrete]="false" [showTickMarks]="false">
              <input matSliderThumb [(ngModel)]="numDays">
            </mat-slider>
            <input type="number" class="days-input" [(ngModel)]="numDays" min="0" max="500" (keydown.enter)="loadData()" (blur)="clampDays('numDays')" />
            <span class="days-suffix">days</span>
          </div>
        </div>

        <div class="filter-field filter-field-days">
          <label class="filter-field-label">Schedule In Past</label>
          <div class="days-input-row">
            <mat-slider [max]="500" [min]="0" [step]="10" [discrete]="false" [showTickMarks]="false">
              <input matSliderThumb [(ngModel)]="pastDays">
            </mat-slider>
            <input type="number" class="days-input" [(ngModel)]="pastDays" min="0" max="500" (keydown.enter)="loadData()" (blur)="clampDays('pastDays')" />
            <span class="days-suffix">days</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



<wc-record-editor *ngIf="editorOpen && def"
                  [def]="def"
                  [title]="editorTitle"
                  [mode]="editorMode"
                  [filter]="filter"
                  [model]="editorModel"
                  (save)="onEditorSave($event)"
                  (cancel)="closeEditor()"
                  [lookups]="lookups">
</wc-record-editor>

<div class="schedule-container">
  <schedules-map [data]="data" [summaryData]="summaryData" *ngIf="activeScreen === 'map'" />
  <div id="frac-grid-container" *ngIf="activeScreen === 'list'">
    <wc-grid gridKey="fracSchedules" [context]="context"
             [contextMenuItems]="gridMenu"
             (contextMenuAction)="onGridMenu($event)" />
  </div>
  <div id="frac-calendar-container" *ngIf="activeScreen === 'calendar'">
    <frac-calendar [data]="data" />
  </div>
</div>

